import React from 'react';
import Dropzone from 'react-dropzone';
import PropTypes from 'prop-types';

const Uploader = props => {
  const { children, handleOnDrop } = props;

  return (
    <Dropzone onDrop={handleOnDrop}>
      {({ getRootProps, getInputProps }) => (
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          {children}
        </div>
      )}
    </Dropzone>
  );
};

Uploader.propTypes = {
  handleOnDrop: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default Uploader;



// WEBPACK FOOTER //
// ./src/sharedComponents/Dropzone/Dropzone.js